export const NOT_FOUND = '85377fc1-feb3-4e4c-b1f0-47ead2125a44';
export const ACCESS_DENIED = '7629bfe8-fa39-44c6-99a7-38c9a9d97e2b';
export const INVALID_PAYLOAD = 'c401ff19-145c-4cf7-8c24-30679f058b5a';
